import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { useApolloClient } from "@apollo/client";
import {
	SelectInvoiceGroupTypesDocument,
	SelectInvoiceGroupTypesQuery,
} from "__generated__/view/invoicegrouptypes/graphql/invoiceGroupType.queries.generated";
import { ChildPropsFromArray } from "types/commons";
import { CharterType } from "__generated__/enums";

export type InvoiceGroupTypeSelectOption = ChildPropsFromArray<SelectInvoiceGroupTypesQuery, "invoiceGroupTypes">;

type InvoiceGroupTypeSelectProps<Multiple extends boolean,> = Omit<SelectProps<InvoiceGroupTypeSelectOption, Multiple>, "fetchOptions"> & {
	charterType: CharterType | null | undefined;
	includeAdvancePayment?: boolean;
	includeParentContractExclusive?: boolean;
};

const InvoiceGroupTypeSelect = <Multiple extends boolean = false,>({ includeAdvancePayment, includeParentContractExclusive, charterType, ...rest }: InvoiceGroupTypeSelectProps<Multiple>) => {
	const client = useApolloClient();

	const onFetchOptions = async() => {

		const response = await client.query({
			query: SelectInvoiceGroupTypesDocument,
			variables: {
				search: {
					excludeAdvancePayment: !includeAdvancePayment,
				},
			},
		});

		const options = (response.data?.invoiceGroupTypes ?? [])
			.filter(x => !charterType || x.charterTypes.includes(charterType));

		return {
			options,
			totalResults: options.length,
		};
	};

	return (
		<Select
			{...rest}
			fetchOptions={onFetchOptions}
			getOptionLabel={(option) => option.name ?? ""} />
	);
};

export default InvoiceGroupTypeSelect;
